export const tr = {
    assign: 'Kaydet',
    cancel: 'İptal',
    'cpa-strategy-note':
        'Teklif sadece "Dönüşüm sayısı optimizasyonu" ve "Tıklama sayısı optimizasyonu" stratejisi içeren filtrelere uygulanır.',
    'cpc-strategy-note': 'Teklif sadece "Tıklama sayısı optimizasyonu" stratejisi içeren filtrelere uygulanır.',
    'rate-label': 'Teklif belirle {rateType}'
};
